import React, { FC, memo, ComponentType, NamedExoticComponent } from "react";

import { Portal } from "../portal";
import { Overlay } from "../overlay";
import { OverflowHidden } from "../side-effects";

import useFocusTrap from "@core-ui/hooks/UseFocusTrap";
import { HalfCardContainer } from "./HalfCardHOC.styled";

export default function HalfCardHOC<T extends object>(PassedComponent: ComponentType<T>): NamedExoticComponent<T> {
    const HalfCardWrappedComponent: FC<T> = (props: T) => {
        useFocusTrap();
        return (
            <Portal>
                <OverflowHidden>
                    <>
                        <HalfCardContainer>
                            <PassedComponent {...props} />
                        </HalfCardContainer>
                        <Overlay />
                    </>
                </OverflowHidden>
            </Portal>
        );
    };

    return memo(HalfCardWrappedComponent);
}
